import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  // getEvents(perPage, page) {
  //   return apiClient.get("/events/?_limit=" + perPage + "&_page=" + page);
  // },
  getEvents() {
    return apiClient.get("/events/");
  },
  getEvent(id) {
    return apiClient.get("/events/" + id);
  },
  postEvent(event) {
    return apiClient.post("/events", event);
  },
};
